// extracted by mini-css-extract-plugin
export default {"otpInputContainer":"OtpInputField_otpInputContainer__51Brr","otpInput":"OtpInputField_otpInput__YVYLE"};